<div class="chart-container">
  <ngx-charts-bar-vertical-2d
    [results]="sensorData"
    [customColors]="customColors"
    [gradient]="false"
    [xAxis]="true"
    [yAxis]="true"
    [legend]="false"
    [legendTitle]="'statistics.legendTitle' | translate"
    [showXAxisLabel]="false"
    [showYAxisLabel]="true"
    [yAxisLabel]="'statistics.units.liters' | translate"
    [barPadding]="2"
    [groupPadding]="5"
  >
    <ng-template #tooltipTemplate let-model="model">
      <div class="chart-tooltip">
        <div class="chart-tooltip__label">
          {{ formatTooltipDate(model.timestamp) }}
        </div>
        <div>
          {{ model.name }}: {{ model.value | localizedNumber: "1.0-2" }} l
        </div>
      </div>
    </ng-template>
  </ngx-charts-bar-vertical-2d>

  <div class="chart-legend">
    @for (series of legendData; track series.name) {
      <div class="chart-legend__item">
        <span
          class="chart-legend__color"
          [style.background-color]="series.color"
        ></span>

        {{ series.name }}
      </div>
    }
  </div>
</div>
